<template>
	<v-layout>
		<v-container fluid lazy>
			<v-flex xs12 class="text-xs-center text-sm-center text-md-center text-lg-center">
				<v-layout wrap>
					<v-text-field
						max-width="350"
						:label="$t('selectimage')"
						@click="pickFile"
						v-model="imageName"
						prepend-icon="attach_file"
					></v-text-field>
					<input type="file" style="display: none" ref="image" accept="image/*" @change="onFilePicked" />

					<div>
						<img :src="prevImage" width="200" v-if="prevImage != null && imageUrl == null" />
						<img :src="imageUrl" width="200" v-if="imageUrl" />
						<img src="../assets/images/no-image.png" height="200" v-if="imageUrl == null && prevImage == null" />
					</div>
				</v-layout>
				<v-layout wrap>
					<!-- Borrar imagen si tenia una previamente -->
					<div v-if="prevImage">
						<v-btn @click.stop="dialogDelete = true">{{ this.$t('deletebtn') }}</v-btn>
					</div>
					<v-dialog v-model="dialogDelete" max-width="450" max-height="450">
						<v-card>
							<v-card-title class="headline">{{ this.$t('deletealert') }}</v-card-title>
							<v-card-text>{{ this.$t('deleteinfo') }}</v-card-text>

							<v-card-actions>
								<v-spacer></v-spacer>

								<v-btn @click="dialogDelete = false">{{ this.$t('cancelar') }}</v-btn>

								<v-btn color="primary" @click="deleteImg()">{{ this.$t('deletebtn') }}</v-btn>
							</v-card-actions>
						</v-card>
					</v-dialog>
					<div v-if="imageFile != null">
						<v-layout>
							<v-btn v-if="!isQuickEdition" @click.stop="dialogUpload = true">{{ this.$t('aceptar') }}</v-btn>
							<v-btn v-else color="primary" @click="insert()">{{ this.$t('aceptar') }}</v-btn>
							<v-btn @click="cancel()">{{ this.$t('cancelar') }}</v-btn>
						</v-layout>
					</div>

					<v-dialog v-model="dialogUpload" max-width="450" max-height="450" persistent>
						<v-card>
							<v-card-title class="headline">{{ this.$t('uploadalert') }}</v-card-title>
							<v-card-text>{{ this.$t('uploadinfo') }}</v-card-text>

							<v-card-actions>
								<v-spacer></v-spacer>
								<v-btn v-if="!loading" @click="dialogUpload = false">{{ this.$t('cancelar') }}</v-btn>
								<v-btn :loading="loading" :disabled="loading" color="primary" @click="insert()">{{ this.$t('aceptar') }}</v-btn>
							</v-card-actions>
						</v-card>
					</v-dialog>
				</v-layout>
			</v-flex>
		</v-container>
	</v-layout>
</template>

<script>
export default {
	data() {
		return {
			dialogDelete: false,
			dialogUpload: false,
			prevImgId: null,
			prevImage: null,
			dialog: false,
			imageName: null,
			imageUrl: null,
			imageFile: null,
			loading: false,
			model: {
				description: this.description,
				filename: null,
				filenameorig: null,
				model: this.modelName,
				pk: {},
				role: this.role
			}
		};
	},

	props: {
		pkName: {
			type: String,
			required: true
		},
		pk: {
			type: [Object, Number],
			required: true
		},
		modelName: {
			type: String,
			required: true
		},
		role: {
			type: String,
			required: true
		},
		description: {
			type: String,
			required: true
		},
		isQuickEdition: {
			type: Boolean,
			required: false,
			default: false
		}
	},

	methods: {
		deleteImg() {
			const url = '/puidocument/delete';
			this.$puiRequests.deleteRequest(
				url,
				null,
				() => {
					this.prevImage = null;
					this.imageFile = null;
					this.dialogDelete = false;
				},
				error => {
					console.log('error: ', error);
				},
				{
					id: this.prevImgId
				}
			);
		},
		// Funciones para pillar la imagen
		pickFile() {
			this.$refs.image.click();
		},

		onFilePicked(e) {
			const files = e.target.files;
			if (files[0] !== undefined) {
				this.imageName = files[0].name;
				if (this.imageName.lastIndexOf('.') <= 0) {
					return;
				}
				const fr = new window.FileReader();
				fr.readAsDataURL(files[0]);
				fr.addEventListener('load', () => {
					this.imageUrl = fr.result;
					this.imageFile = files[0]; //imagen a enviar
					this.model.filename = this.imageFile.name; //elemento del modelo a enviar
					this.model.filenameorig = this.imageFile.name; //elemento del modelo a enviar
					this.model.pk[this.pkName] = this.pk;
					this.prevImage = null;
				});
			} else {
				this.cancel();
			}
		},

		cancel() {
			this.imageName = null;
			this.imageFile = null;
			this.imageUrl = null;
			this.getPrincipalImage();
		},

		// Comprueba los documentos asociados y los sobreescribe
		insert() {
			this.loading = true;
			var url = '/puidocument/getDocuments';

			this.$puiRequests.getRequest(
				url,
				{
					model: this.modelName,
					pk: this.pk,
					role: this.role
				},
				response => {
					var documents = response.data;
					if (documents.length > 0) {
						for (let i = 0; i < documents.length; i++) {
							this.deleteImages(documents[i].id);
						}
						this.uploadImages();
					} else {
						this.uploadImages();
					}
					this.dialogUpload = false;
					this.loading = false;
				},
				error => {
					console.log(error);
				}
			);
		},

		uploadImages() {
			const formData = new window.FormData();
			formData.append('file', this.imageFile, this.imageFile.name);

			const url = '/puidocument/upload';

			this.$puiRequests.uploadFileRequest(
				url,
				formData,
				response => {
					if (response.status === 200) {
						this.$puiNotify.success(this.$t('success2'), this.$t('success'), 3000, false);
						this.imageName = null;
						this.imageFile = null;
						this.imageUrl = null;

						this.getPrincipalImage();
					} else {
						console.log('error', response);
						this.imageName = null;
						this.imageFile = null;
						this.imageUrl = null;
					}
				},
				error => {
					console.log(error);
				},
				this.model
			);
		},

		deleteImages(idDoc) {
			const url = '/puidocument/delete';
			this.$puiRequests.deleteRequest(
				url,
				null,
				() => {},
				error => {
					console.log('error: ', error);
				},
				{
					id: idDoc
				}
			);
		},

		getPrincipalImage() {
			const url = '/puidocument/getDocuments';
			this.$puiRequests.getRequest(
				url,
				{
					model: this.modelName,
					pk: this.pk,
					role: this.role
				},
				response => {
					if (response.data[0]) {
						this.prevImage = response.data[0].url;
						this.prevImgId = response.data[0].id;						
						this.$emit('onFileUploaded',this.prevImage);
					}
				},
				error => {
					console.log(error);
				}
			);
		}
	},

	created() {
		this.getPrincipalImage();
	}
};
</script>

<style></style>
